import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../../config/config';
import { NavLink } from 'react-router-dom';
import Popupform from '../../Popupform/Popupform';
import { FiArrowRight } from 'react-icons/fi';

const Topuniversities = () => {
    const [activeTab, setActiveTab] = useState('B.Tech');
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(20);

    const location = useLocation();
    const navigate = useNavigate();

    // Get search/tag from URL
    const searchParams = new URLSearchParams(location.search);
    const searchQuery = searchParams.get('search');
    const tagQuery = searchParams.get('tag');

    // Course tabs - now clickable
    const courseTabs = [
        'All', 'B.Tech', 'M.Tech', 'MBA', 'MCA', 'BCA',
        'M.Com', 'B.Com', 'BA', 'M.Sc', 'BBA/BMS', 'B.Sc (Nursing)'
    ];

    // Switch to 'All' when searching
    useEffect(() => {
        if (searchQuery) {
            setActiveTab('All');
        }
    }, [searchQuery]);

    // Fetch all college data
    useEffect(() => {
        const fetchCollegeData = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_collegespage`);
                const fetchedData = response.data.collegePages || [];
                setTableData(fetchedData);
                setFilteredData(fetchedData);
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };
        fetchCollegeData();
    }, []);

    // Filter data when tab or search changes
    useEffect(() => {
        let filtered = [...tableData];

        // Filter by search query
        if (searchQuery) {
            filtered = filtered.filter(college =>
                college.collegeName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                college.subheading?.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        // Filter by active tab (course)
        if (activeTab && activeTab !== 'All') {
            filtered = filtered.filter(college =>
                college.coursesDeatils?.some(course =>
                    course.courses?.toLowerCase().includes(activeTab.toLowerCase())
                )
            );
        }

        setFilteredData(filtered);
    }, [activeTab, searchQuery, tableData]);

    const handleOpenPopup = (e) => {
        e.preventDefault();
        setShowPopup(true);
        document.body.style.overflow = "hidden";
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        document.body.style.overflow = "auto";
    };

    const handleTabClick = (course) => {
        setActiveTab(course);
    };

    // Determine banner based on stream/tag
    const getBannerInfo = () => {
        const path = location.pathname;

        if (path.includes('Engineering')) {
            return {
                title: "Top Engineering Colleges in India",
                subtitle: "Explore leading engineering institutions offering B.Tech, M.Tech, and specialized programs with excellent placement records"
            };
        } else if (path.includes('Medical')) {
            return {
                title: "Top Medical Colleges in India",
                subtitle: "Discover premier medical institutions offering MBBS, B.Sc Nursing, and healthcare programs with world-class facilities"
            };
        } else if (path.includes('MBA') || path.includes('Management')) {
            return {
                title: "Top MBA/Management Colleges in India",
                subtitle: "Find the best business schools and management institutes with strong industry connections and placements"
            };
        } else if (searchQuery) {
            return {
                title: `Search Results for "${searchQuery}"`,
                subtitle: "Explore colleges matching your search criteria"
            };
        } else {
            return {
                title: "List of Top Colleges in India Based on 2025 Ranking",
                subtitle: "India is home to some of the finest educational institutions, renowned for their academic excellence, infrastructure, and placement opportunities"
            };
        }
    };

    const bannerInfo = getBannerInfo();

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Banner */}
            <section className="py-16 bg-gradient-to-r from-gray-800 via-gray-700 to-gray-900 text-white">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-4xl font-bold mb-4">{bannerInfo.title}</h1>
                    <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                        {bannerInfo.subtitle}
                    </p>
                </div>
            </section>

            {/* Main Content */}
            <section className="py-16">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl font-bold text-gray-800 mb-8">Top Colleges</h2>

                    {/* Course Filter Tabs */}
                    <div className="flex flex-wrap gap-3 mb-12">
                        {courseTabs.map((course) => (
                            <button
                                key={course}
                                onClick={() => handleTabClick(course)}
                                className={`px-6 py-2 rounded-full border text-sm font-bold transition-all duration-300
                                ${activeTab === course
                                        ? 'bg-blue-600 border-blue-600 text-white shadow-md scale-105'
                                        : 'bg-white border-gray-300 text-gray-700 hover:border-blue-500 hover:text-blue-600 hover:scale-105'
                                    }`}
                            >
                                {course}
                            </button>
                        ))}
                    </div>

                    {/* College Table */}
                    <div className="bg-white rounded-3xl shadow-xl border border-gray-300 overflow-hidden">
                        {/* Header */}
                        <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b border-gray-100 text-xs font-bold text-gray-400 uppercase tracking-widest bg-blue-900 text-white">
                            <div className="col-span-1 text-center">Rank</div>
                            <div className="col-span-7">Colleges</div>
                            <div className="col-span-2">Application Deadline</div>
                            <div className="col-span-2">Course Fees</div>
                        </div>

                        {/* Rows */}
                        {/* Rows */}
                        {filteredData.length > 0 ? (
                            <>
                                {filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((college, index) => (
                                    <React.Fragment key={index}>
                                        {/* Mobile Card View */}
                                        <div className="md:hidden bg-white rounded-2xl shadow-sm border border-gray-200 p-5 mb-4 relative overflow-hidden">
                                            <div className="flex items-start gap-4 mb-4">
                                                {/* Rank Badge */}
                                                <div className="absolute top-0 left-0 bg-yellow-400 text-white text-[10px] font-bold px-3 py-1 rounded-br-lg shadow-sm z-10">
                                                    #{(currentPage - 1) * itemsPerPage + index + 1}
                                                </div>

                                                {/* Image */}
                                                <img
                                                    src={`${config.API_BASE_URL}/${college.image}`}
                                                    alt={college.collegeName}
                                                    className="w-16 h-16 rounded-lg object-contain border border-gray-100 bg-white mt-4 flex-shrink-0"
                                                />

                                                {/* Content */}
                                                <div className="mt-4 flex-1">
                                                    <NavLink
                                                        to={`/college/${college._id}`}
                                                        className="font-bold text-gray-900 leading-tight text-sm block mb-1"
                                                    >
                                                        {college.collegeName}
                                                    </NavLink>
                                                    <p className="text-xs text-gray-500 mb-2">{college.subheading}</p>

                                                    <div className="flex items-center gap-1 text-xs text-green-600 font-bold bg-green-50 px-2 py-1 rounded-md w-fit">
                                                        <span>Admissions Open</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Details Grid */}
                                            <div className="grid grid-cols-2 gap-4 border-t border-gray-100 pt-3 mb-3">
                                                <div>
                                                    <p className="text-[10px] text-gray-400 uppercase font-semibold">First Year Fees</p>
                                                    <p className="text-sm font-bold text-gray-800">
                                                        ₹ {college.coursesDeatils && college.coursesDeatils[0]?.fees ? college.coursesDeatils[0].fees : "2.31 Lakhs"}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p className="text-[10px] text-gray-400 uppercase font-semibold">Application Deadline</p>
                                                    <p className="text-xs font-bold text-gray-800">
                                                        {college.coursesDeatils && college.coursesDeatils[0]?.applicationDate ? college.coursesDeatils[0].applicationDate : "10 June - 18 Jun 2024"}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* Actions */}
                                            <div className="flex gap-2">
                                                <button
                                                    onClick={handleOpenPopup}
                                                    className="flex-1 bg-orange-50 text-orange-600 border border-orange-200 text-xs font-bold py-2.5 rounded-lg hover:bg-orange-100 transition"
                                                >
                                                    Apply Now
                                                </button>
                                                <NavLink
                                                    to={`/college/${college._id}`}
                                                    className="flex-1 bg-gray-50 text-gray-600 border border-gray-200 text-xs font-bold py-2.5 rounded-lg hover:bg-gray-100 transition text-center"
                                                >
                                                    View Details
                                                </NavLink>
                                            </div>
                                        </div>

                                        {/* Desktop Table Row View */}
                                        <div
                                            className="hidden md:grid grid-cols-1 md:grid-cols-12 gap-4 p-5 border-b last:border-0 border-gray-50 hover:bg-blue-50/50 transition items-center"
                                        >
                                            {/* Rank */}
                                            <div className="col-span-1 text-center font-bold text-gray-600">
                                                {(currentPage - 1) * itemsPerPage + index + 1}
                                            </div>

                                            {/* College Info */}
                                            <div className="col-span-7 flex items-center gap-4">
                                                <img
                                                    src={`${config.API_BASE_URL}/${college.image}`}
                                                    alt={college.collegeName}
                                                    className="w-12 h-12 rounded-lg object-contain border border-gray-100 bg-white"
                                                />
                                                <div>
                                                    <NavLink
                                                        to={`/college/${college._id}`}
                                                        className="font-bold text-gray-800 hover:text-blue-600 transition text-sm block"
                                                    >
                                                        {college.collegeName}
                                                    </NavLink>
                                                    <p className="text-xs text-gray-500 mt-0.5">{college.subheading}</p>
                                                    <button
                                                        onClick={handleOpenPopup}
                                                        className="inline-flex items-center gap-1 text-xs font-semibold text-blue-600 hover:gap-2 transition-all mt-1"
                                                    >
                                                        Apply Now <FiArrowRight size={12} />
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Application Deadline */}
                                            <div className="col-span-2">
                                                <p className="text-xs text-gray-700">
                                                    {college.coursesDeatils && college.coursesDeatils[0]?.applicationDate
                                                        ? college.coursesDeatils[0].applicationDate
                                                        : "10 June - 18 Jun 2024"}
                                                </p>
                                            </div>

                                            {/* Fees */}
                                            <div className="col-span-2">
                                                <p className="text-sm font-bold text-green-600">
                                                    ₹{" "}
                                                    {college.coursesDeatils && college.coursesDeatils[0]?.fees
                                                        ? college.coursesDeatils[0].fees
                                                        : "2.31 Lakhs"}
                                                </p>
                                                <p className="text-[10px] text-gray-400">(1st Year Fees)</p>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))}

                                {/* Pagination */}
                                {Math.ceil(filteredData.length / itemsPerPage) > 1 && (
                                    <div className="p-4 bg-gray-50 border-t border-gray-200 flex flex-col md:flex-row items-center justify-center gap-4">
                                        <div className="flex items-center gap-2 overflow-x-auto max-w-full pb-2 md:pb-0 scrollbar-hide">
                                            {/* Previous Button */}
                                            <button
                                                onClick={() => {
                                                    setCurrentPage(prev => Math.max(prev - 1, 1));
                                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                                }}
                                                disabled={currentPage === 1}
                                                className="px-3 py-1 rounded-md border border-gray-300 bg-white text-gray-600 disabled:opacity-50 text-xs font-bold hover:bg-gray-50"
                                            >
                                                Prev
                                            </button>

                                            {/* Page Numbers with Smart Truncation */}
                                            {(() => {
                                                const totalPages = Math.ceil(filteredData.length / itemsPerPage);
                                                let pages = [];
                                                if (totalPages <= 7) {
                                                    pages = Array.from({ length: totalPages }, (_, i) => i + 1);
                                                } else {
                                                    if (currentPage <= 4) {
                                                        pages = [1, 2, 3, 4, 5, '...', totalPages];
                                                    } else if (currentPage >= totalPages - 3) {
                                                        pages = [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
                                                    } else {
                                                        pages = [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
                                                    }
                                                }

                                                return pages.map((page, index) => (
                                                    <button
                                                        key={index}
                                                        onClick={() => {
                                                            if (page !== '...') {
                                                                setCurrentPage(page);
                                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                                            }
                                                        }}
                                                        disabled={page === '...'}
                                                        className={`min-w-[32px] h-8 flex items-center justify-center rounded-full text-xs font-bold transition-all
                                                        ${page === currentPage
                                                                ? 'bg-brand-orange text-white shadow-md scale-110'
                                                                : page === '...'
                                                                    ? 'bg-transparent text-gray-400 cursor-default'
                                                                    : 'bg-white border border-gray-300 text-gray-600 hover:bg-orange-50 hover:text-brand-orange'}`}
                                                    >
                                                        {page}
                                                    </button>
                                                ));
                                            })()}

                                            {/* Next Button */}
                                            <button
                                                onClick={() => {
                                                    setCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredData.length / itemsPerPage)));
                                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                                }}
                                                disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}
                                                className="px-3 py-1 rounded-md border border-gray-300 bg-white text-gray-600 disabled:opacity-50 text-xs font-bold hover:bg-gray-50"
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="text-center py-16">
                                <p className="text-gray-500 text-lg">No colleges found matching your criteria</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {/* Popup Modal */}
            {showPopup && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 relative">
                        <button
                            onClick={handleClosePopup}
                            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl"
                        >
                            ×
                        </button>
                        <Popupform />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Topuniversities;
